var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        [
          _c(
            "v-btn",
            {
              attrs: { flat: "", color: "primary", title: "Refresh" },
              on: { click: _vm.getAllCodes }
            },
            [
              _c("v-icon", { staticClass: "mx-2", attrs: { dark: "" } }, [
                _vm._v("refresh")
              ]),
              _vm._v("\n          " + _vm._s(_vm.$t("refresh")) + "\n    ")
            ],
            1
          ),
          _vm._v(" "),
          _vm.showAddRegistrationCodeBtn
            ? _c(
                "v-btn",
                {
                  attrs: {
                    flat: "",
                    color: "primary",
                    title: "Add registration code"
                  },
                  on: {
                    click: function($event) {
                      return _vm.addCode("tenant")
                    }
                  }
                },
                [
                  _c("v-icon", { staticClass: "mx-2", attrs: { dark: "" } }, [
                    _vm._v("add")
                  ]),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("tenantRegistrationCode")) +
                      "\n    "
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showAddRegistrationCodeBtn
            ? _c(
                "v-btn",
                {
                  attrs: {
                    flat: "",
                    color: "primary",
                    title: "Add registration code"
                  },
                  on: {
                    click: function($event) {
                      return _vm.addCode("warehouse")
                    }
                  }
                },
                [
                  _c("v-icon", { staticClass: "mx-2", attrs: { dark: "" } }, [
                    _vm._v("add")
                  ]),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("warehouseRegistrationCode")) +
                      "\n    "
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.switchEnvForShowBtns
            ? _c(
                "v-flex",
                { attrs: { md7: "" } },
                [
                  _c(
                    "v-layout",
                    {
                      attrs: { "align-center": "", "justify-space-between": "" }
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { md5: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.$t("key"),
                              name: "key",
                              id: "key"
                            },
                            model: {
                              value: _vm.key,
                              callback: function($$v) {
                                _vm.key = $$v
                              },
                              expression: "key"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "ml-2", attrs: { md5: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.$t("email"),
                              name: "email",
                              id: "email"
                            },
                            model: {
                              value: _vm.email,
                              callback: function($$v) {
                                _vm.email = $$v
                              },
                              expression: "email"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-2",
                          attrs: {
                            flat: "",
                            color: "primary",
                            title: "Register"
                          },
                          on: { click: _vm.registerUser }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("registerUser")) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-2",
                          attrs: {
                            flat: "",
                            color: "primary",
                            title: "Verify signup"
                          },
                          on: { click: _vm.verifySignupEmailAuth }
                        },
                        [_vm._v("\n            Verify signup\n        ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { "justify-start": "" } },
        [
          _c("v-flex", { style: { whiteSpace: "pre-wrap" } }, [
            _vm._v(_vm._s(_vm.$t("status")) + ":       " + _vm._s(_vm.status))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.verifySignupResult
        ? _c(
            "v-layout",
            { attrs: { "justify-start": "" } },
            [
              _c("v-flex", { style: { whiteSpace: "pre-wrap" } }, [
                _vm._v(
                  "\n      verifySignupResult: " +
                    _vm._s(JSON.stringify(_vm.verifySignupResult)) +
                    "\n    "
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        [_c("v-progress-linear", { attrs: { indeterminate: _vm.loading } })],
        1
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { sm8: "", md5: "" } },
        [
          _c(
            "v-layout",
            { attrs: { "justify-space-between": "" } },
            [
              _c(
                "v-flex",
                {
                  staticClass: "font-weight-bold text-sm-left",
                  attrs: { sm4: "" }
                },
                [_vm._v(_vm._s(_vm.$t("registrationCode")))]
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  staticClass: "font-weight-bold text-sm-left",
                  attrs: { sm4: "" }
                },
                [_vm._v(_vm._s(_vm.$t("registrationType")))]
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  staticClass: "font-weight-bold text-sm-left",
                  attrs: { sm4: "" }
                },
                [_vm._v(_vm._s(_vm.$t("createTime")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.codes, function(item) {
        return _c(
          "v-layout",
          { key: item.code, attrs: { column: "" } },
          [
            _c(
              "v-layout",
              { attrs: { "justify-start": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { sm8: "", md5: "" } },
                  [
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { staticClass: "text-sm-left", attrs: { sm4: "" } },
                          [_vm._v(_vm._s(item.code))]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { staticClass: "text-sm-left", attrs: { sm4: "" } },
                          [_vm._v(_vm._s(item.type || ""))]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { staticClass: "text-sm-left", attrs: { sm4: "" } },
                          [
                            _vm._v(
                              _vm._s(_vm.toTimestampString(item.createTime))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("v-spacer")
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e9accf66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9accf66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrator.vue
// module id = null
// module chunks = 